import { format } from 'date-fns';
import { t } from 'i18next';

export const DIVISION_VALUE_MATCHER = {
  LTL: 'Freight',
  Commerce: 'Sameday',
};

export const today = new Date();

const isExceptionStatus = (status, statusCode) => (/^Exception - Call Customer Service$/i.test(status)
  || /^Exception - Appeler le service à la clientèle/i.test(status)
  || /^Exception - OSD/i.test(status)
  || /^Livré - OSD/i.test(status))
  && statusCode === 'COMPLETE';

export const makeDataObject = (data) => {
  const DATE_FORMAT_PATTERN = 'EEEE, dd MMM';
  const TIME_FORMAT_PATTERN = 'HH:MM';
  if (data && data.length !== 0) {
    if (!data[0].orderItems) {
      return data.map((entry) => {
        const rawStatus = entry.basicData?.status;
        const exceptionStatus = isExceptionStatus(rawStatus, entry.basicData?.statusCode)
          || (entry.basicData?.trackingItems && entry.basicData.trackingItems.some(
            (tp) => isExceptionStatus(tp.status, tp.statusCode),
          ));
        return {
          freight: entry.probillNumber ?? '',
          reference: entry.referenceNumber ?? '',
          shipper: entry.basicData?.from ?? '',
          shipperAddress: entry.basicData?.from?.address1 ?? '',
          consignee: entry.basicData?.to ?? '',
          consigneeAddress: entry.basicData?.to?.address1 ?? '',
          estimatedDelivery: exceptionStatus ? '' : (entry.basicData?.estimatedDeliveryDate ?? entry.estimatedDeliveryDate ?? ''),
          dateDelivered: exceptionStatus ? '' : (entry.deliveryDate ?? ''),
          orderStatus: exceptionStatus ? t('ExceptionStatus') : rawStatus,
          orderStatusPercentage: entry.statusPercentage ?? '',
          orderStatusColor: entry.statusColor ?? '',
          division: entry.division ?? '',
          tracking: [{
            id: 0,
            date: entry.basicData?.deliveryDate ? format(entry.basicData.deliveryDate, DATE_FORMAT_PATTERN) : '',
            touchPoints: entry.basicData?.trackingItems ? entry.basicData.trackingItems.map((touchPoint, index) => {
              const tpException = isExceptionStatus(touchPoint?.status, touchPoint?.statusCode);
              return {
                id: index,
                time: touchPoint?.date ? format(touchPoint.date, TIME_FORMAT_PATTERN) : null,
                status: tpException ? t('ExceptionStatus') : (touchPoint?.status ?? ''),
                location: tpException ? null : {
                  city: touchPoint?.city ?? '',
                  state: touchPoint?.provinceCode ?? '',
                  country: touchPoint?.countryCode ?? '',
                },
                coords: {
                  latitude: touchPoint?.latitude ?? '',
                  longitude: touchPoint?.longitude ?? '',
                },
              };
            }) : null,
          }],
        };
      });
    }

    return data[0].orderItems
      .filter((entry) => entry.billType !== 'CREDIT' && entry.billType !== 'REBILL')
      .map((entry) => {
        const rawStatus = entry.status ?? '';
        const exceptionStatus = isExceptionStatus(rawStatus, entry.statusCode)
          || (entry.tracking && entry.tracking.some((event) =>
            (event.touchPoints || []).some((tp) => isExceptionStatus(tp.status, tp.statusCode))));
        return {
          billAccount: entry.billAccount ?? '',
          freight: entry.shipmentNumber ?? '',
          reference: entry.customerReferenceNumber ?? '',
          shipper: entry.from ?? '',
          shipperAddress: entry.from.address1 ?? '',
          consignee: entry.to ?? '',
          consigneeAddress: entry.to.address1 ?? '',
          estimatedDelivery: exceptionStatus ? '' : (entry.estimatedDeliveryDate ?? ''),
          dateDelivered: exceptionStatus ? '' : (entry.deliveryDate ?? ''),
          orderStatus: exceptionStatus ? t('ExceptionStatus') : rawStatus,
          orderStatusPercentage: entry.statusPercentage ?? '',
          orderStatusColor: entry.statusColor ?? '',
          orderId: entry.orderId ?? '',
        };
      });
  }

  return undefined;
};
